module.exports = __webpack_public_path__ + "img/maquina-enfardadora-packetgrup.955999c8.jpg";